import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

export const useTextTranslate = (text) => {
  const { i18n } = useTranslation();
  const [translatedText, setTranslatedText] = useState(text || "");

  useEffect(() => {
    const translateText = async () => {
      if (!text?.trim()) {
        setTranslatedText("");
        return;
      }

      try {
        const { data } = await axios.get(
          "https://translate.googleapis.com/translate_a/single",
          {
            params: {
              client: "gtx",
              sl: "auto",
              tl: i18n.language,
              dt: "t",
              q: text,
            },
          }
        );

        const translated = data?.[0]
          ?.map((part) => part?.[0] || "")
          .join(" ")
          .trim();

        setTranslatedText(translated || text);
      } catch {
        setTranslatedText(text);
      }
    };

    translateText();
  }, [text, i18n.language]);

  return translatedText;
};


export const getTranslatedText = async (text, language) => {
  if (!text?.trim()) return "";

  try {
    const { data } = await axios.get(
      "https://translate.googleapis.com/translate_a/single",
      {
        params: {
          client: "gtx",
          sl: "auto",
          tl: language,
          dt: "t",
          q: text,
        },
      }
    );

    const translated = data?.[0]
      ?.map((part) => part?.[0] || "")
      .join(" ")
      .trim();

    return translated || text;
  } catch (err) {
    console.error(err);
    return text;
  }
};

